import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { postBoard } from '../requests';
import type { PostBoardRequest } from '../types';

export const usePostBoard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: PostBoardRequest) => postBoard(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.organisationBoards],
      });
    },
  });
};
